








































































































































































































































































import { Component, Vue, Prop } from 'vue-property-decorator';
import {
  MultipleRecurrenceFrequencyOptions,
  RecurrenceSettingPayload,
  DataCollectionPeriodDTO,
  ProjectDetailPayload,
  DataCollectionPeriodSettingsPayload,
} from '@/store/modules/projects/types/projects.types';
import { StringInputOption } from '@/jbi-shared/types/form.types';
import ProjectCreationMultipleDatePicker from './ProjectCreationMultipleDatepicker.vue';
import moment from 'moment';
import { getStartDateTime, getEndDateTime } from '../../../utils/date.util';
import AuditCycleDataSetup from './AuditCycleDataSetup.vue';
import {
  AuditSamplingType,
  MultipleRecurrenceType,
  RecurrenceType,
} from '@/jbi-shared/types/project.types';
import { cloneData } from '@/utils/general.util';
import { AuditSamplingTypeDisplayOptions } from '@/store/modules/audits/types/audits.types';
const dirtyMonths = [
  'Jan',
  'Feb',
  'Mar',
  'Apr',
  'May',
  'Jun',
  'Jul',
  'Aug',
  'Sept',
  'Oct',
  'Nov',
  'Dec',
];

@Component({
  components: {
    ProjectCreationMultipleDatePicker,
    AuditCycleDataSetup,
  },
})
export default class NewAuditSettings extends Vue {
  @Prop() public projectDetail!: ProjectDetailPayload;
  @Prop() public latestDate!: Date;
  @Prop({ type: Array, default: () => [] })
  public projectCriteria!: Array<{
    title: string;
    uniqueCriteriaId: string | number;
  }>;
  @Prop({ type: Array, default: () => [] })
  public projectSites!: Array<{ id: number; name: string }>;
  @Prop({ type: Array, default: () => [] })
  public projectDataCollectors!: Array<{
    email: string;
    siteIds: number[];
  }>;
  @Prop() public auditCount!: number;
  @Prop() public prevAuditCriteriaIds!: number[];

  public projectExpiryDatePicker: any = null;
  public defaultEndDate: any = moment(this.latestDate).add(1, 'M');
  public initialDataCollectionPeriodData: DataCollectionPeriodDTO = {
    auditNumber: 1,
    auditName: this.getAuditName(0),
    startDate: getStartDateTime(this.latestDate),
    endDate: getEndDateTime(this.defaultEndDate.subtract(1, 'd')),
    auditCriteriaIds: this.prevAuditCriteriaIds, // Default prev audit cycle criteria should be selected
    auditSiteIds: this.projectSites.map((ps) => ps.id),
    auditParticipants: cloneData(this.projectDataCollectors),
  };
  public dirtyRecurrenceSetting: RecurrenceSettingPayload = {
    recurrenceType: RecurrenceType.ONE_OFF,
    multipleRecurrenceType: MultipleRecurrenceType.DAILY,
    auditSamplingType: AuditSamplingType.TARGET_SAMPLE_SIZE,
    interval: 1,
    auditNumber: 1,
    scheduledRecurrenceStartDate: getStartDateTime(this.latestDate),
    scheduledRecurrenceEndDate: null,
    enableGrip: true,
    dataCollectionPeriodSettings: [
      {
        ...this.initialDataCollectionPeriodData,
      },
    ],
  };
  public dataCollectionPeriodKey: number = Math.floor(Math.random() * 999);
  public showTotalError: boolean = false;
  public showIntervalError: boolean = false;

  public getAuditName(index: number): string {
    return this.auditCount !== 0
      ? 'Follow-Up ' + Number(this.auditCount + index)
      : 'Baseline';
  }

  public getAuditCycleDataSetupKey(index: number) {
    let key = Math.floor(Math.random() * 999);
    return `audit_cycle_${key++}_${index}`;
  }

  get RecurrenceTypeOptions(): RecurrenceType[] {
    return [RecurrenceType.ONE_OFF, RecurrenceType.MULTIPLE];
  }

  get RecurrenceType(): typeof RecurrenceType {
    return RecurrenceType;
  }

  get AuditSamplingType(): typeof AuditSamplingType {
    return AuditSamplingType;
  }

  get auditSamplingTypeDisplayOptions() {
    return AuditSamplingTypeDisplayOptions;
  }

  get selectedSamplingType(): AuditSamplingType {
    return this.dirtyRecurrenceSetting.auditSamplingType;
  }

  set selectedSamplingType(newValue) {
    this.dirtyRecurrenceSetting.auditSamplingType = newValue;
    this.dataCollectionPeriodKey += 1;
    this.$emit('updateAuditSetting', this.dirtyRecurrenceSetting);
  }

  get selectedRecurrenceType(): RecurrenceType {
    return this.dirtyRecurrenceSetting.recurrenceType;
  }

  set selectedRecurrenceType(newValue) {
    this.dirtyRecurrenceSetting.recurrenceType = newValue;
    this.dirtyRecurrenceSetting.auditNumber = 1;
    this.dirtyRecurrenceSetting.interval = 1;
    this.dirtyRecurrenceSetting.multipleRecurrenceType =
      newValue === RecurrenceType.MULTIPLE
        ? MultipleRecurrenceType.MONTHLY
        : null;

    if (newValue === RecurrenceType.MULTIPLE) {
      this.updateTotalDataCollectionPeriod();
    }
    this.$emit('updateAuditSetting', this.dirtyRecurrenceSetting);
  }

  get scheduledRecurrenceStartDate() {
    const recurrenceStartDate: any = getStartDateTime(
      this.dirtyRecurrenceSetting.scheduledRecurrenceStartDate,
    );

    return typeof recurrenceStartDate === 'string'
      ? getStartDateTime(recurrenceStartDate)
      : recurrenceStartDate;
  }

  set scheduledRecurrenceStartDate(newValue) {
    this.dirtyRecurrenceSetting.scheduledRecurrenceStartDate = getStartDateTime(
      newValue,
    );
    this.dataCollectionPeriodKey += 1;
    this.$emit('updateAuditSetting', this.dirtyRecurrenceSetting);
  }

  get dataCollectionPeriods() {
    return this.dirtyRecurrenceSetting.dataCollectionPeriodSettings
      ? this.dirtyRecurrenceSetting.dataCollectionPeriodSettings
      : this.updateTotalDataCollectionPeriod();
  }

  get multipleRecurrenceFrequencyOptions(): StringInputOption[] {
    return Object.entries(MultipleRecurrenceFrequencyOptions).map(
      ([key, value]) => {
        return {
          id: key,
          name: value,
        };
      },
    );
  }

  get multipleRecurrenceType() {
    return this.dirtyRecurrenceSetting.multipleRecurrenceType !== undefined &&
      this.dirtyRecurrenceSetting.multipleRecurrenceType
      ? this.dirtyRecurrenceSetting.multipleRecurrenceType
      : MultipleRecurrenceType.MONTHLY;
  }

  set multipleRecurrenceType(newValue) {
    this.dirtyRecurrenceSetting.multipleRecurrenceType = newValue;
    this.dataCollectionPeriodKey += 1;
    this.$emit('updateAuditSetting', this.dirtyRecurrenceSetting);
  }

  get interval(): number {
    return this.dirtyRecurrenceSetting.interval
      ? this.dirtyRecurrenceSetting.interval
      : 0;
  }

  set interval(newValue: number) {
    this.dirtyRecurrenceSetting.interval = newValue;
    this.showIntervalError = !newValue || newValue < 1 ? true : false;
    this.dataCollectionPeriodKey += 1;
    this.$emit('updateAuditSetting', this.dirtyRecurrenceSetting);
  }

  get auditNumber(): number {
    return this.dirtyRecurrenceSetting.auditNumber
      ? this.dirtyRecurrenceSetting.auditNumber
      : 0;
  }

  set auditNumber(newValue: number) {
    this.dirtyRecurrenceSetting.auditNumber = newValue;
    this.showTotalError = newValue === 0 ? true : false;
    this.dataCollectionPeriodKey += 1;
    this.$emit('updateAuditSetting', this.dirtyRecurrenceSetting);
  }

  /** Returns title and description for each recurrence type, used for display purposes  */
  public recurrenceTypeDisplayInfo(
    type: RecurrenceType,
  ): {
    title: string;
    infotext1: string;
  } {
    switch (type) {
      case RecurrenceType.ONE_OFF:
        return {
          title: 'One-off',
          infotext1: 'Add 1 new data collection period to the project.',
        };
      case RecurrenceType.MULTIPLE:
        return {
          title: 'Multiple',
          infotext1:
            'Add multiple new data collection period to the project that will start and stop at a scheduled time.',
        };
      default:
        return {
          title: '',
          infotext1: '',
        };
    }
  }

  /**
   * Handles assigning auditCriteriaIds, auditSiteIds, and auditParticipants to the selected index,
   * then emits the updated data to the parent component to reflect the changes
   */
  public handleUpdatedCycleData(
    data: {
      auditCriteriaIds: Array<string | number>;
      auditSiteIds: number[];
      auditParticipants: Array<{ email: string; siteIds: number[] }>;
    },
    index: number,
  ) {
    // Store the selected data in the recurrence settings
    this.dirtyRecurrenceSetting.dataCollectionPeriodSettings[
      index
    ].auditCriteriaIds = data.auditCriteriaIds;
    this.dirtyRecurrenceSetting.dataCollectionPeriodSettings[
      index
    ].auditSiteIds = data.auditSiteIds;
    this.dirtyRecurrenceSetting.dataCollectionPeriodSettings[
      index
    ].auditParticipants = data.auditParticipants;

    // Emit update to parent
    this.$emit('updateAuditSetting', this.dirtyRecurrenceSetting);

    // Also emit the criteria and sites separately
    this.$emit('update-selections', {
      criteria: data.auditCriteriaIds,
      sites: data.auditSiteIds,
    });
  }

  public getDate(newValue: Date): string {
    return (
      newValue.getDate() +
      ' ' +
      dirtyMonths[newValue.getMonth()] +
      ' ' +
      newValue.getFullYear()
    );
  }

  public formatDateRange(date: Date): string {
    return this.getDate(date);
  }

  public updateDataCollectionPeriodInitialSettings(newValue: {
    auditName: string;
    auditNumber: number;
    startDate: Date;
    endDate: Date;
  }) {
    const tempUpdatedSettings = {
      ...this.dirtyRecurrenceSetting,
    };

    tempUpdatedSettings.dataCollectionPeriodSettings[newValue.auditNumber] = {
      ...tempUpdatedSettings.dataCollectionPeriodSettings[newValue.auditNumber],
      ...newValue,
    };

    this.$emit('updateAuditSetting', tempUpdatedSettings);
  }

  /**
   * Updates initial settings for the selectedRecurrenceType 'MULTIPLE'.
   *
   * When the user selects the number of recurrence cycles,
   * this function generates and initializes the default data structure for each cycle.
   */

  public updateTotalDataCollectionPeriod() {
    const dataCollectionPeriodSettings = [];
    const scheduledStartDate = moment(this.scheduledRecurrenceStartDate);
    if (this.selectedRecurrenceType !== RecurrenceType.MULTIPLE) {
      dataCollectionPeriodSettings.push({
        startDate: getStartDateTime(scheduledStartDate),
        endDate: null,
        auditNumber: 1,
        auditName: this.getAuditName(0),
        auditCriteriaIds:
          this.prevAuditCriteriaIds.length > 0
            ? this.prevAuditCriteriaIds
            : this.projectCriteria.map((pc) => pc.uniqueCriteriaId), // Default prev audit cycle criteria should be selected
        auditSiteIds: this.projectSites.map((ps) => ps.id),
        auditParticipants: cloneData(this.projectDataCollectors),
      });
    } else {
      let auditNumberValue = this.auditNumber;
      /** Reset auditNumberValue to 1 if it exceeds 10, and exit early to prevent further processing */
      if (auditNumberValue > 10) {
        auditNumberValue = 1;
        return;
      }

      for (let value = 0; value < auditNumberValue; value++) {
        const startDate =
          value > 0
            ? scheduledStartDate.add(1, 'd').toDate()
            : scheduledStartDate.toDate();
        const newAuditName = this.getAuditName(value);
        switch (this.multipleRecurrenceType) {
          case Object.keys(MultipleRecurrenceFrequencyOptions)[0]:
            scheduledStartDate.add(this.interval, 'd');
            break;
          case Object.keys(MultipleRecurrenceFrequencyOptions)[1]:
            scheduledStartDate.add(this.interval, 'w');
            break;
          case Object.keys(MultipleRecurrenceFrequencyOptions)[2]:
            scheduledStartDate.add(this.interval, 'M');
            break;
          default:
            scheduledStartDate.add(this.interval, 'y');
            break;
        }
        const newEndDate: Date = scheduledStartDate.subtract(1, 'd').toDate();
        const dateRangePeriod: Date[] = [startDate, newEndDate];

        dataCollectionPeriodSettings.push({
          startDate: getStartDateTime(dateRangePeriod[0]),
          endDate: getEndDateTime(dateRangePeriod[1]),
          auditNumber: value + 1,
          auditName: newAuditName,
          auditCriteriaIds:
            this.prevAuditCriteriaIds.length > 0
              ? this.prevAuditCriteriaIds
              : this.projectCriteria.map((pc) => pc.uniqueCriteriaId), // Default prev audit cycle criteria should be selected
          auditSiteIds: this.projectSites.map((ps) => ps.id),
          auditParticipants: cloneData(this.projectDataCollectors),
        });
      }
    }

    const multipleAuditCyclesData: DataCollectionPeriodSettingsPayload = {
      ...dataCollectionPeriodSettings,
    };
    this.dirtyRecurrenceSetting.dataCollectionPeriodSettings = multipleAuditCyclesData;
    this.$emit('updateAuditSetting', this.dirtyRecurrenceSetting);
    return multipleAuditCyclesData;
  }
}
